<div class="d-flex align-items-center auth px-0">
    <div class="row w-100 mx-0">
        <div class="col-12 col-lg-10 col-xl-7 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
                <div class="brand-logo">
                    <a routerLink="../login">
                        <img src="assets/images/logo.svg" alt="agaia logo">
                    </a>
                </div>
                <form class="pt-3" [formGroup]="resetPasswordForm">
                    <div class="form-group">
                        <input #passwordInput type="password" name="password" class="form-control form-control-lg"
                               [placeholder]="'auth_password' | localise" formControlName="password"/>
                    </div>
                    <div class="form-group">
                        <input #repeatPasswordInput type="password" name="repeatPassword"
                               class="form-control form-control-lg" [placeholder]="'auth_repeat_password' | localise"
                               formControlName="repeatPassword"/>
                    </div>
                    <div class="mt-3">
                        <button class="p-10 btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                                [disabled]="!resetPasswordForm.valid || passwordInput.value !== repeatPasswordInput.value"
                                (click)="onChangePassword()">
                            {{ 'auth_change_password' | localise }}
                        </button>
                    </div>
                </form>

                <div style="text-align: center;cursor: pointer;margin-top: 20px;">
                    <a class="nav-link dropdown-toggle" [app-popup]="{
              templateRef: languagesPopupTemplate,
              position: 'top',
              arrowPosition: ['top', 'center'],
              paddingless: true,
              closeUponSelection: true
            }">
                        <i class="ti-world mx-0"></i>
                        {{ 'change_language' | localise }}
                    </a>
                </div>

                <ng-template #languagesPopupTemplate>
                    <a class="dropdown-item preview-item" *ngFor="let language of languages"
                       (click)="onLanguageSelected(language)">
                        <div class="preview-thumbnail">
                            <div class="responsive-flex-wrapper">
                                <i [ngClass]="'m-0 flag-icon flag-icon-' + flagIcon(language)"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">{{ language | localise }}</div>
                    </a>
                </ng-template>
            </div>
        </div>
    </div>
</div>
